const ITEMS = [
    "Festive Offer",
    "Only ₹199/-",
    "Business",
    "Artificial Intelligence",
    "Digital Marketing",
    "Finance & Investing",
    "Self-Improvement",
    "Health & Fitness",
    "Programming & Tech",
    "Entrepreneurship",
    "Sales",
    "Psychology",
    "Productivity",
    "Freelancing",
    "Stock Market & Trading",
    "Personal Finance",
    "Communication Skills",
    "Career & Education",
];

function Row({ hidden = false }) {
    return (
        <div aria-hidden={hidden} className="flex shrink-0 items-center">
            {ITEMS.map((c) => (
                <span
                    key={c}
                    className={`flex items-center gap-8 whitespace-nowrap px-8 font-display text-sm font-semibold uppercase tracking-[0.2em] sm:text-base ${
                        ["Festive Offer", "Only ₹199/-"].includes(c)
                            ? "text-amber-300"
                            : "text-emerald-100/90"
                    }`}
                >
                    {c}
                    <span className="text-amber-400">✦</span>
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div
            data-testid="category-marquee"
            className="marquee-wrap overflow-hidden bg-emerald-950 py-4 sm:py-5"
        >
            <div className="animate-marquee flex w-max">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
